import React, { useState } from "react";
import { Modal } from "reactstrap";
import { Field, Form } from "react-final-form";
import { useMutation } from "react-query";
import { createErrors } from "../../../queries/helpers";
import { createInvite } from "../../../queries/invite";
import ValidatedInput from "../../common/ValidatedInput";
import PropTypes from "prop-types";
import { insertItem } from "../../../redux/reducers/helpers";

const InviteModal = ({
  queryDataString,
  modal,
  toggle,
  handleError,
  queryClient,
}) => {
  const [showSuccessImage, setShowSuccessImage] = useState(false);
  const [type, setType] = useState("Developer");
  const handleRadioChange = (e) => {
    setType(e.target.value);
  };

  const newInvite = useMutation(async (formData) => {
    return await createInvite(formData);
  });

  const onSubmit = async (values) => {
    values.type = type;
    return await newInvite
      .mutateAsync(values)
      .then((invite) => {
        queryClient.setQueryData(queryDataString, (oldData) => {
          return insertItem(oldData, invite);
        });
        setShowSuccessImage(true);
      })
      .catch((error) => {
        return createErrors(error, "Failed to create invite", handleError);
      });
  };

  return (
    <Modal
      id="invitation-modal"
      tabIndex="-1"
      isOpen={modal}
      toggle={toggle}
      className={"modal-dialog modal-dialog-centered"}
    >
      {showSuccessImage ? (
        <div>
          <div className="mw-96 mx-auto">
            <svg
              className="w-100"
              viewBox="-34 -18 585 585.33459"
              width="585pt"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="m511.453125 211.320312-95.34375-80.734374v-15.058594c.003906-2.324219-.921875-4.546875-2.566406-6.183594l-106.785157-106.570312c-.027343-.023438-.054687-.039063-.078124-.0625-1.644532-1.730469-3.933594-2.710938-6.316407-2.710938-.332031 0-.660156.0195312-.984375.0585938l-.152344-.015625c-.292968-.0273438-.585937-.0429688-.878906-.0429688h-151.011718c-26.683594.0273438-48.300782 21.652344-48.335938 48.332031v82.308594l-94.828125 80.425781c-3.078125 1.433594-5.042969 4.515625-5.046875 7.910156v271.097657c.039062 32.390625 26.285156 58.636719 58.675781 58.675781h399.507813c32.390625-.039062 58.644531-26.285156 58.675781-58.675781v-271.097657c0-3.1875-1.734375-6.125-4.53125-7.65625zm-17.726563 7.890626-77.617187 65.832031v-131.554688zm-184.625-189.410157 77.367188 77.207031h-46.515625c-17.03125-.019531-30.832031-13.820312-30.851563-30.855468zm-161.765624-12.324219h144.289062v58.679688c.027344 26.679688 21.648438 48.304688 48.328125 48.332031h58.675781v175.378907l-114.355468 96.992187c-15.339844 13.082031-37.917969 13.09375-53.269532.023437l-114.523437-96.96875v-251.582031c.019531-17.03125 13.824219-30.835937 30.855469-30.855469zm-48.335938 136.078126v131.558593l-77.617188-65.726562zm-41.199219 377.71875c-9.015625.003906-17.785156-2.960938-24.945312-8.441407l119.476562-122.207031c3.328125-3.460938 3.238281-8.949219-.1875-12.304688-3.429687-3.351562-8.925781-3.3125-12.304687.085938l-118.367188 121.066406c-3.203125-5.964844-4.875-12.628906-4.871094-19.398437v-251.832031l85.574219 72.464843.007813.007813 117.523437 99.511718c21.867188 18.617188 54.019531 18.605469 75.867188-.035156l202.933593-172.109375v251.992188c.007813 6.792969-1.671874 13.484375-4.898437 19.46875l-119.070313-121.15625c-3.382812-3.4375-8.917968-3.484375-12.363281-.101563-3.4375 3.382813-3.488281 8.914063-.101562 12.359375l120.132812 122.21875c-7.152343 5.464844-15.902343 8.414063-24.898437 8.410157zm0 0" />
              <path
                fill="#de337c"
                d="m234.921875 265.394531c3.082031 3.609375 8.480469 4.097657 12.164063 1.101563l56.039062-45.59375c2.441406-1.964844 3.644531-5.085938 3.160156-8.179688-.496094-3.097656-2.605468-5.691406-5.535156-6.804687-2.933594-1.113281-6.238281-.566407-8.65625 1.429687l-49.421875 40.207032-18.523437-21.691407c-2.019532-2.410156-5.175782-3.546875-8.265626-2.984375-3.085937.566406-5.636718 2.742188-6.675781 5.707032-1.042969 2.964843-.410156 6.257812 1.648438 8.625zm0 0"
              />
              <path d="m257.554688 333.050781c44.957031 0 83.910156-31.164062 93.78125-75.023437 9.871093-43.863282-11.976563-88.707032-52.601563-107.96875-40.617187-19.257813-89.167969-7.796875-116.878906 27.601562-22.671875 28.953125-26.835938 68.304688-10.726563 101.359375 16.101563 33.0625 49.65625 54.035157 86.425782 54.03125zm-61.941407-144.605469c23.679688-30.265624 65.765625-38.996093 99.527344-20.640624 33.761719 18.351562 49.324219 58.414062 36.800781 94.746093-12.523437 36.332031-49.464844 58.296875-87.363281 51.953125-37.902344-6.347656-65.671875-39.15625-65.675781-77.585937-.03125-17.574219 5.851562-34.648438 16.710937-48.472657zm0 0" />
            </svg>
          </div>
          <h4 className="text-center mt-4 mb-3">Invitation sent!</h4>

          <p className="text-center mb-4">What do you want to do next?</p>

          <div className="text-center">
            <button
              id="invite-send-2"
              type="button"
              className="btn btn-main"
              onClick={() => {
                setShowSuccessImage(false);
              }}
            >
              Invite more users
            </button>
            <button
              type="button"
              className="btn btn-sm btn-cancel"
              data-dismiss="modal"
              onClick={() => {
                toggle();
                setShowSuccessImage(false);
              }}
            >
              Close
            </button>
          </div>
        </div>
      ) : (
        <div>
          <h4 className="text-center mb-4">Invite user</h4>
          <p className="text-small">
            {"Type the user's email and select an appropriate role:"}
          </p>
          <Form
            onSubmit={onSubmit}
            render={({
              submitError,
              handleSubmit,
              form,
              submitting,
              pristine,
              values,
            }) => (
              <form onSubmit={handleSubmit}>
                <div className="mt-3">
                  <Field
                    inputClassName="fin-control"
                    name="email"
                    component={ValidatedInput}
                    type="email"
                    placeholder="eg email@company.com"
                  />
                  <div className="fin-col text-center">
                    <label className="custom-radio form-control-inline">
                      <input
                        type="radio"
                        name="group1"
                        value="Admin"
                        onChange={(e) => handleRadioChange(e)}
                      />
                      <span>Admin</span>
                    </label>
                    <label className="custom-radio form-control-inline">
                      <input
                        type="radio"
                        name="group1"
                        value="Developer"
                        checked={true}
                        onChange={(e) => handleRadioChange(e)}
                      />
                      <span>Viewer</span>
                    </label>
                  </div>
                </div>

                <div className="text-center">
                  <button
                    id="submit"
                    className="btn btn-main minw-200"
                    disabled={submitting || pristine}
                  >
                    Invite user
                  </button>
                </div>
              </form>
            )}
          />
        </div>
      )}
    </Modal>
  );
};

InviteModal.propTypes = {
  modal: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  handleError: PropTypes.func.isRequired,
  queryClient: PropTypes.object.isRequired,
};

export default InviteModal;
